export const FeedbackForm = () => {
  return (
    <div className="w-full h-full">
      <iframe
        src="https://automatic-knight-27d.notion.site/ebd/1936114c3d778015a180c86aa7f107eb"
        width="100%"
        height="100%"
        allowFullScreen
        title="Support Request"
      />
    </div>
  );
};
